// src/components/common/DepartmentGroup.jsx
import { motion } from "framer-motion";
import { Building2 } from "lucide-react";

const DepartmentGroup = ({ title, departments, selectedDeptName, onSelectDept, isLeadership = false }) => (
  <div className="department-group">
    {title && <h3 className="group-title">{title}</h3>}
    <div className="dept-grid">
      {departments.map((dept) => (
        <motion.div key={dept.name}  className={`dept-card ${selectedDeptName === dept.name || (selectedDeptName?.name === dept.name && !isLeadership) ? "active" : ""}`} onClick={() => onSelectDept(isLeadership ? dept.name : dept)}>
          <div className="dept-icon">
            <Building2 size={24} />
          </div>
          <div className="dept-name">{dept.name}</div>
        </motion.div>
      ))}
    </div>
  </div>
);

export default DepartmentGroup;